import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { A } from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Rating from 'components/common/Rating'

const StoreRating = ({
  reviewName,
  ratingValues: {
    ratingCount = 0,
    reviewsCount = 0,
    ratingMax = 5
  } = {},
  writeReviewUrl,
  openReviewsTabHandler
}) =>
  <React.Fragment>
    <Rating
      inline
      anchor
      storeRating
      reviewName={ reviewName }
      ratingCount={ ratingCount }
      reviewsCount={ reviewsCount }
      ratingMax={ ratingMax }
      noReviews
      showRatingMax
      showStarsOnly={ Boolean(!reviewsCount) }
      handler={ openReviewsTabHandler } />
    <Separator />
    <A bolder prevent data-at-store-readreviews data-printless handler={ openReviewsTabHandler }>
      Read Reviews
    </A>
    <Separator data-desktop-only />
    <StyledA data-at-store-writereview bolder href={ writeReviewUrl } target="_blank" data-printless>Write a Review</StyledA>
  </React.Fragment>

export default StoreRating

StoreRating.propTypes = {
  openReviewsTabHandler: PropTypes.func,
  ratingValues: PropTypes.shape(),
  reviewName: PropTypes.string,
  writeReviewUrl: PropTypes.string
}

const Separator = styled.span`
  height: 16px;
  margin: 0 12px;
  vertical-align: middle;
  border-right: 1px solid ${Theme.colors.light_grey};
  ${Media.desktop`
    display: inline-block;
  `}
`

const StyledA = styled(A)`
  ${Media.mobile`
    display: block;
    padding: 5px 0;
  `}
`
